import { render, staticRenderFns } from "./ComplementaInformacion.vue?vue&type=template&id=9cad032e"
import script from "./ComplementaInformacion.vue?vue&type=script&lang=js"
export * from "./ComplementaInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cad032e')) {
      api.createRecord('9cad032e', component.options)
    } else {
      api.reload('9cad032e', component.options)
    }
    module.hot.accept("./ComplementaInformacion.vue?vue&type=template&id=9cad032e", function () {
      api.rerender('9cad032e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/ComplementaInformacion.vue"
export default component.exports